/*  ==========================================================================
    EHOTELIER CONFIG
    @todo
    ========================================================================== */

/*
 * IMPORTS
 */

import * as priceLists from "./lib/price-lists";


/*
 * EXPORTS
 */

export {
    priceLists
};


// WEBPACK FOOTER //
// ./source/js/globals/config/ehotelier/ehotelier-config.js